import dayjs from "dayjs";

/**
 * 구독 종료일 기준 남은 일수 계산
 * 현재 시점부터 종료 시점까지의 시간을 일수로 변환 (버림 처리)
 * @param endDate - 구독 종료일시
 * @returns 남은 일수 (최소 0)
 */
export const calculateRemainingDays = (endDate: string | Date): number => {
  const end = dayjs(endDate);
  const now = dayjs();

  // 종료 시점이 현재보다 미래인 경우에만 계산
  if (end.isAfter(now)) {
    // 시간 차이를 구한 후 24시간으로 나누고 버림
    // 예: 23시간 남음 → 0일, 25시간 남음 → 1일
    const remainingHours = end.diff(now, 'hours', true);
    return Math.floor(remainingHours / 24);
  }

  return 0;
};